import * as blogImgStyle from "./image.module.scss";

import { GatsbyImage, getImage } from "gatsby-plugin-image";

import Breadcrumbs from "../../Breadcrumbs";
import React from 'react';

export default function BlogImage({ featuredImage, featuredImageAlt, breadcrumbs }) {
  return (
    <section className={blogImgStyle.blog__header} id='blog-details-banner'>
      <div className={blogImgStyle.blog__header__container}>
        <ul className={blogImgStyle.breadcrumbs}>
          {breadcrumbs.map((item, index) => (
            <Breadcrumbs item = {item} key={index}/>
            ))
          }
        </ul>
      </div>
      <GatsbyImage image={getImage(featuredImage)} alt={featuredImageAlt}/>
    </section>
  )
}
